import { useOutletContext } from 'react-router-dom';
import type { WebsiteAppContextValue } from '../appContext';

export function useWebsiteAppContext(): WebsiteAppContextValue {
  return useOutletContext<WebsiteAppContextValue>();
}
